import { useMutation, useQueryClient } from "react-query";
import { ECoursesQueryKeys } from "api/endpoints/courses";
import { addCourseLessonToGroup } from "api/services/courses";
import { logError } from "utils/notifications";
import { TAddCourseLessonToGroupBody } from "types/api/course";
import { TApiError } from "types/api/error";
import { TUrlParam } from "types/utils";

export const useAddCourseLessonToGroup = () => {
  const queryClient = useQueryClient();
  return useMutation<
    void,
    TApiError,
    {
      courseId: TUrlParam;
      lessonId: TUrlParam;
      body: TAddCourseLessonToGroupBody;
    }
  >(
    ({ courseId, lessonId, body }) =>
      addCourseLessonToGroup(courseId, lessonId, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(ECoursesQueryKeys.getAllCourseLessons);
      },
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
